// extracted by mini-css-extract-plugin
export var layoutTotLife = "layoutTotLife-module--layoutTotLife---qJjY";
export var totLifeArticleSummaries = "layoutTotLife-module--totLifeArticleSummaries--Kqn9u";
export var totLifeHeader = "layoutTotLife-module--totLifeHeader--KQdQI";
export var totLifeTopics = "layoutTotLife-module--totLifeTopics--4QUlc";